import { put, takeEvery} from 'redux-saga/effects';
import { push } from 'connected-react-router';
//import { reset } from 'redux-form';

//import resolveRedirectTo from 'util/resolveRedirectTo'; 나중에 필요할지도 몰라서 일단 주석처리

export function* handleRedirection({
    meta: { redirectTo },
}) {
    yield put(push(redirectTo));
}

export default function* redirection() {
    yield takeEvery(
        action => action.meta && typeof action.meta.redirectTo !== 'undefined',
        handleRedirection
    );
}